export default "__VITE_ASSET__CW00wwqx__"